import React, { useEffect, useState } from 'react';
import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Typography,
  CircularProgress,
  Button,
} from '@mui/material';
import axios from 'axios';
import SuperAdminLayout from '../../../layouts/SuperAdminLayout';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import api from '../../../utils/api';

const PurchaseReport = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const user = JSON.parse(localStorage.getItem('user'));

  useEffect(() => {
    const fetchSales = async () => {
      try {
        const res = await api.get(`/api/reports/purchase-report/${user.id}`);
        setData(res.data);
      } catch (err) {
        console.error('Error fetching sales report:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchSales();
  }, [user.id]);

  const exportToExcel = (data, fileName) => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

    const excelBuffer = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });

    const blob = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    saveAs(blob, `${fileName}.xlsx`);
  };

  return (
    <SuperAdminLayout>
      <Typography variant="h6" sx={{ mt: 2 }}>
        Purchase Report
      </Typography>

      <Button
        variant="contained"
        color="success"
        sx={{ mb: 2 }}
        onClick={() => exportToExcel(data, 'Sales_Report')}
      >
        Download Excel
      </Button>
      {loading ? (
        <CircularProgress />
      ) : (
        <TableContainer component={Paper} sx={{ mt: 2 }}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Challan #</TableCell>
                <TableCell>Party Name</TableCell>
                <TableCell>Products</TableCell>
                <TableCell>Quantities</TableCell>
                <TableCell>Rates</TableCell>
                <TableCell>Totals</TableCell>
                <TableCell>Date</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {data.map((row, idx) => (
                <TableRow key={idx}>
                  <TableCell>{row.challanNumber}</TableCell>
                  <TableCell>{row.partyName}</TableCell>
                  <TableCell>
                    {row.products.map((p, i) => (
                      <div key={i}>{p.name}</div>
                    ))}
                  </TableCell>
                  <TableCell>
                    {row.products.map((p, i) => (
                      <div key={i}>{p.quantity}</div>
                    ))}
                  </TableCell>
                  <TableCell>
                    {row.products.map((p, i) => (
                      <div key={i}>₹{p.rate}</div>
                    ))}
                  </TableCell>
                  <TableCell>
                    {row.products.map((p, i) => (
                      <div key={i}>₹{p.total}</div>
                    ))}
                  </TableCell>
                  <TableCell>{row.date}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </SuperAdminLayout>
  );
};

export default PurchaseReport;
